const communities = [
  { name: "Belgrade", zip: "59714", note: "8 miles west on I-90" },
  { name: "Four Corners", zip: "59718", note: "5 miles west" },
  { name: "Livingston", zip: "59047", note: "28 miles east on I-90" },
  { name: "Manhattan", zip: "59741", note: "18 miles west" },
  { name: "Three Forks", zip: "59752", note: "30 miles west" },
  { name: "Big Sky", zip: "59716", note: "45 miles south on US-191" },
];

export default function LocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Serving Bozeman and the Entire Gallatin Valley
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Fast Passport Center handles passport services for residents across greater Bozeman — including Downtown, the University District, Bridger Canyon, and surrounding Gallatin County communities. The nearest Regional Passport Agency is in Denver, over 400 miles away via I-90/I-25. We eliminate that trip entirely.
            </p>
            <div className="bg-[#F7F8FA] rounded-lg p-5 mb-6">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-2-line text-[#F6C344] text-lg"></i>
                </div>
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm mb-1">Nearest Passport Agency</p>
                  <p className="text-gray-500 text-sm">Denver Regional Passport Agency — 3151 S Vaughn Way, Suite 600, Aurora, CO 80014 — 400+ miles southeast via I-90/I-25. Fast Passport Center eliminates this trip for Bozeman residents.</p>
                </div>
              </div>
            </div>
            <div className="bg-[#F7F8FA] rounded-lg p-5">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i className="ri-flight-takeoff-line text-[#F6C344] text-lg"></i>
                </div>
                <div>
                  <p className="font-semibold text-[#1A365D] text-sm mb-1">Bozeman Yellowstone International Airport (BZN)</p>
                  <p className="text-gray-500 text-sm">Montana&apos;s busiest airport. Serving Bozeman travelers with nonstop flights to 25+ cities including Denver, Seattle, LAX, Chicago, and New York — all requiring a valid passport for international connections.</p>
                </div>
              </div>
            </div>
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.15em] text-gray-400 mb-4">Communities We Serve</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {communities.map((c, i) => (
                <div key={i} className="flex items-center gap-3 bg-[#F7F8FA] rounded-lg p-4">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                    <i className="ri-map-pin-line text-[#1A365D] text-sm"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-[#1A365D] text-sm">{c.name}</p>
                    <p className="text-gray-400 text-xs">ZIP {c.zip} &middot; {c.note}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 p-4 bg-[#EEF2F8] rounded-lg flex items-start gap-3">
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-[#1A365D] text-lg"></i>
              </div>
              <p className="text-[#1A365D] text-sm leading-relaxed">
                <strong>Don&apos;t see your city?</strong> Fast Passport Center serves all Montana zip codes — mail-in service means no geographic restriction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}